<template>
  <div>
    <CRow class="pb-3 pt-3">
      <CCol>
        <div for="">Start Date</div>
        <VDatePicker
          :disabled="isDisabledStartDate"
          v-model="startDate" 
          type="datetime"
          :format="timeFormat"
          :title-format="timeFormat"
          :disabled-date="checkStartDate"
          :append-to-body="false"
          @change="changeAuctionStartDate"
        />
      </CCol>
      <CCol>
        <div>End Date</div>
        <VDatePicker 
          :disabled="isDisabledEndDate"
          v-model="endDate" 
          type="datetime"
          :format="timeFormat"
          :title-format="timeFormat"
          :disabled-date="checkEndDate"
          :append-to-body="false"
          @change="changeAuctionEndDate"

        />
      </CCol>
    </CRow>
    <CRow>
      <CCol v-if="allowStartButton">
        <CButton
          color="info"
          @click="doStart"
          :disabled="sending"
        >Start</CButton>
      </CCol>
      <CCol v-if="allowPauseButton">
        <CButton
          color="info"
          @click="doPause"
          :disabled="sending"
        >Pause</CButton>
      </CCol>
      <CCol v-if="allowContinueButton">
        <CButton
          color="info"
          @click="doContinue"
          :disabled="sending"
        >Continue</CButton>
      </CCol>
      <CCol v-if="allowRestartButton">
        <CButton
          color="info"
          @click="doRestart"
          :disabled="sending"
        >Restart</CButton>
      </CCol>
      
    </CRow>
  <CRow class="mt-2">
    <CCol v-if="allowFinishButton">
        <CButton
          color="info"
          @click="doFinish"
          :disabled="sending"
        >End Auction</CButton>
      </CCol>
  </CRow>
  </div>
</template>
<script>
import { CAR_STATE, CAR_STATUS } from '@/utils/dictionaries/car'
import { getStatus, isReversePriceNotMeet, isZeroBids } from '@/utils/validation/car'
import {
  createAuctionManagerMixin,
  auctionManagerStore
} from '@/mixins/auctionsManagerMixin'
import moment from 'moment'
import {
  createCarManagerMixin,
  carManagerStore
} from "@/mixins/carManagerMixin";
export default {
  name: 'VAuctionFormControls',
  
  mixins: [
    createAuctionManagerMixin(),
    createCarManagerMixin()

  ],

  props: {
    car: {
      type: Object,
      default: () => ({})
    },
    changeAuctionStartDate: {
      type: Function
    },
    changeAuctionEndDate: {
      type: Function
    },
  },

  computed: {
    carData() {
      return this[carManagerStore.getterTypes.GETTER_CAR];
    },
    timeFormat() {
      return 'YYYY-MM-DD hh:mm:ss a'
    },
    isDisabledStartDate() {
      return this.carStatus === CAR_STATUS.Progress || this.carStatus === CAR_STATUS.Pause || (this.carStatus === CAR_STATUS.Ended && !this.allowRestartButton)
    },
    isDisabledEndDate() {
      return this.carStatus === CAR_STATUS.Ended && !this.allowRestartButton
    },
    allowStartButton() {
      return this.carStatus === CAR_STATUS.Awaiting
    },
    allowPauseButton() {
      return this.carStatus === CAR_STATUS.Progress
    },
    allowContinueButton() {
      return this.carStatus === CAR_STATUS.Pause
    },
    allowRestartButton() {
      return isReversePriceNotMeet(this.car) || isZeroBids(this.car)
    },
    allowFinishButton() {
      return this.carStatus === CAR_STATUS.Pause || this.carStatus === CAR_STATUS.Progress
    },
    carStatus() {
      return getStatus(this.car)
    }
  },

  data: () => ({
    startDate: '',
    endDate: '',
    sending: false
  }),

  watch: {
    carData(v) {
      if (v?.startDate) {
        this.startDate =  moment(v?.startDate).toDate()
        this.changeAuctionStartDate(this.startDate)
      }

      if (v?.endDate) {
        this.endDate = moment(v?.endDate).toDate()
        this.changeAuctionEndDate(this.endDate)

      }
    }
  },

  methods: {
    checkStartDate(date) {
      return moment(date).isBefore(moment().startOf('day'))
    },
    checkEndDate(date) {
      let endDate = moment(date).format('YYYY-MM-DD')
      let startDate = moment(this.startDate).format('YYYY-MM-DD')
      return !moment(endDate).isSameOrAfter(moment(startDate))
    },
    toCurrentFormat(date) {
      return date ? moment(date).format(this.timeFormat) : moment().format(this.timeFormat)
    },
    async doStart() {
      this.sending = true
      try {
        await this[auctionManagerStore.actionTypes.ACTION_SET_STATE]({
          carId: this.car.id,
          state: CAR_STATE.Start,
          startDate: this.toCurrentFormat(),
          endDate: this.toCurrentFormat(this.endDate)
        })

        this.$emit('success')
      } catch (error) {
        console.log(error)
      } finally {
        this.sending = false
      }
    },

    async doPause() {
      this.sending = true
      try {
        await this[auctionManagerStore.actionTypes.ACTION_SET_STATE]({
          carId: this.car.id,
          state: CAR_STATE.Pause,
          startDate: this.toCurrentFormat(this.startDate),
          endDate: this.toCurrentFormat(this.endDate)
        })

        this.$emit('success')
      } catch (error) {
        console.log(error)
      } finally {
        this.sending = false
      }
    },

    async doContinue() {
      this.sending = true
      try {
        await this[auctionManagerStore.actionTypes.ACTION_SET_STATE]({
          carId: this.car.id,
          state: CAR_STATE.Continue,
          startDate: this.toCurrentFormat(this.startDate),
          endDate: this.toCurrentFormat(this.endDate)
        })

        this.$emit('success')
      } catch (error) {
        console.log(error)
      } finally {
        this.sending = false
      }
    },

    async doRestart() {
      this.sending = true
      try {
        await this[auctionManagerStore.actionTypes.ACTION_SET_STATE]({
          carId: this.car.id,
          state: CAR_STATE.Restart,
          startDate: this.toCurrentFormat(this.startDate),
          endDate: this.toCurrentFormat(this.endDate)
        })

        this.$emit('success')
      } catch (error) {
        console.log(error)
      } finally {
        this.sending = false
      }
    },

    async doFinish() {
      this.sending = true
      try {
        await this[auctionManagerStore.actionTypes.ACTION_SET_STATE]({
          carId: this.car.id,
          state: CAR_STATE.Finish,
          startDate: this.toCurrentFormat(this.startDate),
          endDate: this.toCurrentFormat(this.endDate)
        })

        this.$emit('success')
      } catch (error) {
        console.log(error)
      } finally {
        this.sending = false
      }
    },

    async saveDates() {
      this.sending = true

      try {
        await this[auctionManagerStore.actionTypes.ACTION_SET_STATE]({
          carId: this.car.id,
          startDate: this.toCurrentFormat(this.startDate),
          endDate: this.toCurrentFormat(this.endDate)
        })
      } catch (error) {
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
<style>
</style>